import axiosClient, { ResponseSuccess, ResponseSuccessActive, ResponseSuccessTotal } from "../axiosClient";

export interface IRank {
  id: number
  type: number
  status: number
  title: string
  icon: string
  price: number
  totalAmount: number
  sortOrder: number
  logicOperator: any
  totalCarePolicies: number
  totalPurchaseAmount: number
  totalServiceAmount: number
  totalBenefits: number
  totalBenefitPolicies: number
}

export interface IRankPolicie {
  id: number
  title: string
  icon: string
  code: string
  description: string
  totalBenefitPolicies: number

      categoryCar: string,
  benefitPolicyNames?: string
  dateStart?: string
  dateEnd?: string
}

export interface ICardCustomer {
  listBenefit: ListBenefit[]
  infoCustomer: InfoCustomer
  point: number
}

export interface ListBenefit {
  id: number
  title: string
  description: string
  status: number
}

export interface InfoCustomer {
  status: number
  timestamp: string
  customer: Customer
  rank: Rank
}

export interface Customer {
  username: string
  image: string
}

export interface Rank {
  id: number
  icon: string
  title: string
}
export interface IInfoRank {
  id: number
  code: string
  title: string
  totalAmount: number
  totalServiceAmount: number
  totalPurchaseAmount: number
  totalOwnerVehicles: number
  logicOperator: string
  sortOrder: number
  type: number
  icon: string
  benefits: Array<any>
  benefitPolicies: Array<any>
  carePolicies: ICarePolicy[]
}

export interface ICarePolicy {
  id: number
  code: string
  title: string
  dateStart: string
  dateEnd: string
  brands: string
  cars: string
  benefitPolicies: Array<{
    id: number
    code?: string
    title?: string
    description?: string
  }>
}

export interface IInfoCarePolicie {
  id: number
  code: string
  title: string
  description: string
  dateStart: string
  dateEnd: string
  totalOwnerVehicle: number
  benefitPolicies: Array<{
    id: number,
    description: string,
    title: string
  }>
  categoryCar: Array<{
    id: number
    code: string
    title: string
  }>
  car: Array<{
    id: number
    code: string
    title: string
  }>
}



export type ISearchCardCustomer = {
  infoCustomer: {
    id: number
    codeCard: string
    customerId: number
    rankId: number
    releaseDate: string
    expirationDate: any
    rankTitle: string
    rankIcon: string
    code: string
    username: string
    totalPurchaseAmount: string
    totalServiceAmount: string
    totalAmount: string
    listPhone: Array<string>
    listEmail: Array<string>
    listAddress: Array<{
      id: number
      address: string
      district: {
        id: number
        title: string
        prefix: any
      }
      province: {
        id: number
        title: string
        areaId: number
      }
      fullAddress: string
    }>
  }
  infoRank: {
    id: number
    title: string
    icon: string
    logicOperator: string
    type: number
  }
  nextRankInfo: {
    type: number
    nextRankId: number
    nextRankTitle: string
    nextRankIcon: string
    logicOperator: string
    purchase: {
      totalPurchaseAmount: number
      customerTotalPurchaseAmount: number
      remainingAmount: number
      isMet: boolean
      message: string
    }
    service: {
      totalServiceAmount: number
      customerTotalServiceAmount: number
      remainingAmount: number
      isMet: boolean
      message: string
    }
    isHighestRank: boolean
    message: string

    totalAmount: number
    customerTotalAmount: number
    remainingAmount: number

  }
}



export const activeRank = async (id: number
) => {
  const path = "/rank/activeRank"
  const params = {
    id
  }
  const result: ResponseSuccessActive<[]> = await axiosClient.put(
    path, params
  );
  return result;
};

export const getInfoRank = async (id: number
) => {
  const path = "rank/infoRank"
  const params = {
    id
  }
  const result: ResponseSuccess<IInfoRank> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getInfoCarePolicie = async (id: number
) => {
  const path = "/rank/infoCarePolicie"
  const params = {
    id
  }
  const result: ResponseSuccess<IInfoCarePolicie> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getListRank = async (
) => {
  const path = "rank/listRank"
  const params = {
  }
  const result: ResponseSuccessTotal<IRank[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListCarePolicies = async (
  limit?: number, pageNumber?: number, search?: string, dateStart?: string, dateEnd?: string
) => {
  const path = "/rank/listCarePolicie"
  const params = {
    limit, pageNumber, search, dateStart, dateEnd
  }
  const result: ResponseSuccessTotal<IRankPolicie[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListCarePoliciesByCustomer = async (
  customerId: number, limit?: number, pageNumber?: number, search?: string,
) => {
  const path = "/rank/listCarePoliciesByCustomer"
  const params = {
    customerId, limit, pageNumber, search
  }
  const result: ResponseSuccessTotal<IRankPolicie[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const addRank = async (
  title?: string, code?: string, totalAmount?: number, image?: File | null,
  totalServiceAmount?: number, totalPurchaseAmount?: number, totalOwnerVehicles?: number,
  logicOperator?: string, sortOrder?: number, type?: number,
  listBenefits?: number[], listBenefitPolicies?: number[], listCarePolicies?: number[]
) => {
  const path = "rank/addRank"
  const params = {
    title, code, totalAmount, image,
    totalServiceAmount, totalPurchaseAmount, totalOwnerVehicles,
    logicOperator, sortOrder, type,
    listBenefits, listBenefitPolicies, listCarePolicies
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    path, params
  );
  return result;
};

export const addCarePolicie = async (
  title?: string, code?: string, listCategoryCar?: number[], listCar?: number[], listBenefitPolicies?: number[], dateStart?: string, dateEnd?: string, totalOwnerVehicle?: number
) => {
  const path = "/rank/addCarePolicie"
  const params = {
    title, code, listCategoryCar, listCar, listBenefitPolicies, dateStart, dateEnd, totalOwnerVehicle
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    path, params
  );
  return result;
};

export const editRank = async (
  id: number, title: string, code: string, totalAmount: number, image: File | null,
  totalServiceAmount?: number, totalPurchaseAmount?: number, totalOwnerVehicles?: number,
  logicOperator?: string, sortOrder?: number, type?: number,
  listBenefits?: number[], listBenefitPolicies?: number[], listCarePolicies?: number[]
) => {
  const path = "rank/editRank"
  const params = {
    id, title, code, totalAmount, image,
    totalServiceAmount, totalPurchaseAmount, totalOwnerVehicles,
    logicOperator, sortOrder, type,
    listBenefits, listBenefitPolicies, listCarePolicies
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};

export const editCarePolicie = async (
  id: number, title: string, code: string, listCategoryCar: number[], listCar: number[], listBenefitPolicies: number[], dateStart?: string, dateEnd?: string, totalOwnerVehicle?: number
) => {
  const path = "/rank/editCarePolicie"
  const params = {
    id, title, code, listCategoryCar, listCar, listBenefitPolicies, dateStart, dateEnd, totalOwnerVehicle
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};

//Thông tin chi tiết thẻ phát hành
export const getInfoCardCustomer = async (
  id: number
) => {
  const path = "rank/infoCardCustomer"
  const params = {
    id
  }
  const result: ResponseSuccess<ICardCustomer> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const deleteRank = async (
  id: number
) => {
  const path = "rank/deleteRank"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    path, { params }
  );
  return result;
};




export const searchCardCustomer = async (
  code: string
) => {
  const path = "/rank/searchCardCustomer"
  const params = {
    code
  }
  const result: ResponseSuccess<ISearchCardCustomer> = await axiosClient.get(
    path, { params }
  );
  return result;
};

